import * as React from 'react';
import { UserContext } from '../../context/UserContext';
import AccessDenied from '../shared/AccessDenied';
import LoadingScreen from '../../components/shared/loading/LoadingScreen';
import PanelGroups from '../../components/group_management/groups/PanelGroups';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';

const GroupManagementView = () => {
  // Track module duration.
  useModuleDurationTracking('Configuration', 'Group Management');

  const { user } = React.useContext(UserContext);
  return user === null ? <LoadingScreen /> : user.super_admin ? <PanelGroups /> : <AccessDenied />;
};

export default GroupManagementView;
